/**
 * Table markup (shadcn-style): wraps `<table>` in a horizontal scroll div.
 *
 * Recommended order: `Table` → `TableHeader` / `TableBody` → `TableRow` → `TableHead` | `TableCell`.
 * Actions column: place `TableRowActionsMenu` in `TableCell` with `className="text-right"` + align trigger (see that component).
 */
import React from 'react';
import { cn } from '../cn';
const Table = ({ className, containerClassName, children, ...props }) => {
    return (React.createElement("div", { className: cn('relative w-full overflow-auto', containerClassName) },
        React.createElement("table", { className: cn('w-full caption-bottom text-sm', className), ...props }, children)));
};
const TableHeader = ({ className, children, ...props }) => {
    return (React.createElement("thead", { className: cn('[&_tr]:border-b', className), ...props }, children));
};
const TableBody = ({ className, children, ...props }) => {
    return (React.createElement("tbody", { className: cn('[&_tr:last-child]:border-0', className), ...props }, children));
};
const TableRow = ({ className, children, ...props }) => {
    return (React.createElement("tr", { className: cn('border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted', className), ...props }, children));
};
const TableHead = ({ className, children, ...props }) => {
    return (React.createElement("th", { className: cn('h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0', className), ...props }, children));
};
const TableCell = ({ className, children, ...props }) => {
    return (React.createElement("td", { className: cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className), ...props }, children));
};
export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };
